import { RequestSender } from "./helpers";

type AuthAndPopulateClassWalletSessionInput = {
  readonly orderId: string;
  readonly password: string;
  readonly userAuthType: "sign-up" | "sign-in";
  readonly priceLookupKey: string;
};

async function authAndPopulateClassWalletSessionItemsNoStu(
  request: RequestSender,
  {
    orderId,
    userAuthType,
    password,
    priceLookupKey,
  }: AuthAndPopulateClassWalletSessionInput,
): Promise<void> {
  const response = await request<any>(
    "put",
    `/class-wallet/order-sessions/${encodeURIComponent(orderId)}/items`,
    {
      userAuthType,
      password,
      priceLookupKey,
    },
  );
  if (response.status !== 204) {
    throw new Error(response.data.message);
  }
}

export type { AuthAndPopulateClassWalletSessionInput };
export default authAndPopulateClassWalletSessionItemsNoStu;
